import type { HelpFile } from '../../types/help'
import { NewRequestButtonsTestIds } from '../../../testids/NewRequestButtonsTestIds'

export const newRequestButtonsHelp: HelpFile = {
  docPage: '/docs/my-iam/requests',
  texts: {
    [NewRequestButtonsTestIds.btnNewRequest]:
      'Request one or more Access Profiles for yourself or another identity via the access request wizard.',
    [NewRequestButtonsTestIds.btnNewFgRequest]:
      'Request a function-group bundle — a set of related Access Profiles defined by a function group.',
  },
}
